module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/099-albania-988f8163478c9c96b28e30bf8cbd2b21.svg";